var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { nodedxf2, TYPE_FOLD } from "../Drawing/nodedxf2";
import { stringify, parse } from "../zipson";
import { findMaterial } from "../Quote/Materials/MaterialFuncs";
import { useAPI } from "../Api";
import { calcSetupFees } from "./SetupFees";
import { useLibrary } from "../Api/Library/Provider";
import { toaster } from "evergreen-ui";
export const CartContext = React.createContext({
    add: () => { },
    remove: () => { },
    count: 0,
    cartItems: null,
    indexOf: () => -1,
    update: () => __awaiter(void 0, void 0, void 0, function* () { }),
    clearCart: () => { },
    loading: true,
    updating: false,
});
export const useCart = () => React.useContext(CartContext);
export function CartProvider(props) {
    const API = useAPI();
    const { items: LibraryItems, loading: LibraryLoading, findChildFromPath, } = useLibrary();
    const [cartItems, _setCartItems] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [updating, setUpdating] = React.useState(false);
    let acount = cartItems ? cartItems.length : 0;
    let setCartItems = (items) => {
        let fees = calcSetupFees(items);
        Object.keys(fees.lines).forEach((key) => {
            let v = fees.lines[key];
            let id = indexOf(key, items);
            items[id].SetupFee = Number(v);
        });
        setUpdating(false);
        return _setCartItems(items);
    };
    let indexOf = (key, items = null) => {
        if (!items)
            items = cartItems;
        return (items || []).map((v) => v.key).indexOf(key);
    };
    let AddtoCart = (item) => {
        let items = !cartItems ? [] : [...cartItems];
        // throw new Error('No Cart in add to Cart')
        if (!Array.isArray(item))
            item = [item];
        item.map((i) => {
            if (indexOf(i.key, items) < 0) {
                return items.push(i);
            }
            return UpdateCart(i);
        });
        return setCartItems(items);
    };
    let removeFromCart = (key) => {
        const itemExists = indexOf(key) > -1 ? true : false;
        if (itemExists) {
            let n = [...cartItems.filter((v) => v.key != key)];
            setCartItems(n.length > 0 ? n : []);
        }
    };
    let UpdateCart = (order) => __awaiter(this, void 0, void 0, function* () {
        let i = indexOf(order.key);
        if (i < 0)
            return;
        cartItems[i] = yield updateI(order);
        setCartItems([...cartItems]);
    });
    let clearCart = () => {
        setCartItems([]);
    };
    let slimCartItems = () => {
        if (!cartItems)
            return [];
        return cartItems
            .map((item) => {
            let i = Object.assign({}, item);
            i.drawing = null;
            i.book = null;
            return i;
        })
            .filter((v) => v);
    };
    React.useEffect(() => {
        //cartItems is null before it loads
        if (cartItems != null) {
            localStorage.setItem("cartcomp", stringify(slimCartItems()));
        }
    }, [cartItems]);
    let updateI = (i) => __awaiter(this, void 0, void 0, function* () {
        setUpdating(true);
        if (!i.book && i.bookfile) {
            let book = findChildFromPath(i.bookfile.split(":"));
            if (!book) {
                toaster.warning(`Sorry, One of your Drawings (${i.display}) is missing, and has been removed from the cart.`, { duration: 100 });
                return;
            }
            i.book = book;
        }
        if (i.book) {
            i.drawing = nodedxf2(i.book.dxf);
            let newBends = i.drawing.Drawables.filter((v) => v.Type == TYPE_FOLD);
            i.drawing.bends = i.bends.map((prev, index) => {
                //sometimes, there is no id?
                if (newBends[index] && newBends[index].id) {
                    prev.id = newBends[index].id;
                }
                return prev;
            });
        }
        if (!i) {
            throw new Error("No Book to update");
        }
        const m = yield API.getMaterial(i);
        if (!m) {
            console.error("failed to update Material when updating Cart");
            return i;
        }
        i.selMaterial = findMaterial(m.Materials, i.selMaterial);
        i.RawSetupFee = m.SetupFee;
        return i;
    });
    React.useEffect(() => {
        if (LibraryItems && cartItems == null) {
            let j = localStorage.getItem("cartcomp");
            if (!j)
                return setCartItems([]);
            let items = parse(j);
            if (items && items.length > 0) {
                let updateitems = (items) => __awaiter(this, void 0, void 0, function* () {
                    for (let index = 0; index < items.length; index++) {
                        setLoading(index);
                        items[index] = yield updateI(items[index]);
                    }
                    return items.filter((v) => v);
                });
                updateitems(items).then((i) => {
                    setCartItems([...i]);
                    setLoading(false);
                });
            }
            else
                setLoading(false);
        }
    }, [LibraryItems, LibraryLoading]);
    return (React.createElement(CartContext.Provider, { value: {
            add: AddtoCart,
            remove: removeFromCart,
            count: acount,
            cartItems: cartItems,
            indexOf: indexOf,
            update: UpdateCart,
            clearCart: clearCart,
            loading,
            updating,
        } }, props.children));
}
